/// Componente que renderiza los botones en las tabs y le da interaccion ///

import { TriangleIcon } from "../icons/index";

const SliderEventsButtons = ({ active, index, setActive, event }) => {
  return (
    <button
      key={index}
      className={
        active === index ? "sliderEvents__item isActive" : "sliderEvents__item"
      }
      onClick={() => setActive(index)}
    >
      <TriangleIcon />
      <h3>
        {event.text} <p>{event.underlined}</p>
      </h3>
    </button>
  );
};

export default SliderEventsButtons;
